import React from 'react'
import { Link } from 'react-router-dom'
import classes from './List.module.scss'

type MenuItem = { id: number; name: string; link: string }
type MenuCategory = { id: number; name: string; link: string; subMenu?: MenuItem[] }

type Props = {
  dataList: MenuCategory
  allFavorites?: number[]
}

const List: React.FC<Props> = ({ dataList, allFavorites = [] }) => {
  const title = (dataList?.name ?? '').trim()
  const items = (dataList?.subMenu ?? []) as MenuItem[]
  const isFavCategory = title === 'Sık Kullanılanlar'

  return (
    <div className={classes.listContainer}>
      {title !== '' && (
        <div className={classes.menuTitle} style={isFavCategory ? { color: '#fbc02d', fontWeight: 'bold' } : {}}>
          {isFavCategory && <span style={{ marginRight: 8 }}>⭐</span>}
          {title}
        </div>
      )}

      {items.map((item) => {
        if (item?.id == null) return null
        const isStarred = allFavorites.includes(Number(item.id))

        return (
          <div
            className={classes.menuItem}
            key={item.id}
            style={isStarred ? { backgroundColor: 'rgba(255, 215, 0, 0.12)', borderRadius: '4px' } : {}}
          >
            <Link className={classes.Link} to={item.link}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {isStarred && <span style={{ color: '#fbc02d' }}>★</span>}
                {item.name}
              </div>
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default List